import { bool, string } from 'prop-types'

export const imageWithButtonType = {
  imageUrl: string.isRequired,
  imageAlt: string.isRequired,
  buttonText: string.isRequired,
  buttonLink: string.isRequired,
  wideImage: bool,
}
